module.exports = __webpack_public_path__ + "img/4879a9afd56232a4af5e1781fe4de088.png";